import Link from "next/link";
import type { ReactNode } from "react";

interface BackLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

export function BackLink({ href, children, className = "" }: BackLinkProps) {
  return (
    <Link
      href={href}
      className={`flex flex-wrap opacity-70 hover:opacity-100 items-center break-words gap-1.5 sm:gap-2.5 type-body-s-regular ${className}`}
    >
      {children}
    </Link>
  );
}
